import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { TAttribute, TAttributeDeleteResponse, TCreateAttribute } from './attributes.types.ts';

export const attributesApi = {
  getAllAttributes: async () => {
    const response = await axios.get<TAttribute[]>('attributes', { params: { sort: 'asc' } });

    return response.data;
  },
  getAttributeById: async (id: number) => {
    const response = await axios.get<TAttribute>(`attributes/${id}`);

    return response.data;
  },
  createAttribute: async (attribute: TCreateAttribute) => {
    const response = await axios.post<TAttribute>('attributes', attribute);

    return response.data;
  },
  updateAttribute: async (payload: { id: number; attribute: Partial<TAttribute> }) => {
    const { id, attribute } = payload;
    const response = await axios.patch<TAttribute>(`attributes/${id}`, attribute);

    return response.data;
  },
  deleteAttribute: async (id: number) => {
    const response = await axios.delete<TAttributeDeleteResponse>(`attributes/${id}`);

    return response.data;
  },
};

export const attributesQueries = createQueryKeys('attributes', {
  getAllAttributes: () => ({
    queryKey: ['list'],
    queryFn: () => attributesApi.getAllAttributes(),
  }),
  getAttributeById: (id: number) => ({
    queryKey: ['attribute', id],
    queryFn: () => attributesApi.getAttributeById(id),
  }),
});
